import type { PasoTour } from "./tiposTour";

type AyudaTemporalPaso = Pick<PasoTour, "contenidoLectura">;

interface CrearAyudaPasoTemporalOptions {
  contenidoLectura?: string[];
}

export const crearAyudaPasoTemporal = ({
  contenidoLectura,
}: CrearAyudaPasoTemporalOptions): AyudaTemporalPaso => ({
  contenidoLectura: (contenidoLectura ?? []).map((item) => item.trim()).filter(Boolean),
});
